<template>
	<div id="app" class="root">
		<AsyncAppMenu ref="menu"></AsyncAppMenu>
		<div ref="content" class="content-container">
			<transition name="fade" mode="out-in">
				<router-view />
			</transition>
		</div>
	</div>
</template>

<script>
const AsyncAppMenu = () => import('@/components/AppMenu')
export default {
	components: {
		AsyncAppMenu,
	},
	computed: {},
}
</script>

<style lang="scss">
.root {
	box-sizing: border-box;
	@include d-flex-column;
	position: relative;
}
.fade-enter-active,
.fade-leave-active {
	transition-duration: 0.3s;
	transition-property: opacity;
	transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
</style>
